import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapComponent } from './google-map.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GoogleMapComponent],
  exports: [GoogleMapComponent]
})
export class GoogleMapModule { }



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/google-map/google-map.module.ts